/**
 * Gatekeeper C4. A style converted to a feed style keeps its shelf stock on the old style
 * (K500-OLD). A confirmed map line says which new product (K500) each old product replaces, so an
 * old item can fill a job order line for its new product, the way an alternate style can.
 *
 * The map is exact: an old item fills only the line of the product it is mapped to.
 */
export type ReplacementMap = Map<number, number>; // old product id -> new product id

export type MappedVerdict = "mapped" | "mappedElsewhere" | null;

export class PullMatchFns {
  /**
   * "mapped": the item's product is mapped to the line's product. "mappedElsewhere": it is mapped
   * to another product, so it cannot fill this line. null: the map says nothing about the item.
   */
  static mappedVerdict(map: ReplacementMap, itemProductId: number, lineProductId: number): MappedVerdict {
    const target = map.get(itemProductId);
    if (target == null) return null;
    return target === lineProductId ? "mapped" : "mappedElsewhere";
  }

  static mappedElsewhereMessage(style: string): string {
    return `The item replaces a different product of style ${style}. Scan a different item.`;
  }
}
